import React, { useState } from 'react';

export default function CustomerPortal() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const orderHistory = [
    { id: 'ORD-2024-001', date: '2024-01-15', items: 'Diamond Ring Set', amount: '₹2,50,000', status: 'delivered' },
    { id: 'ORD-2024-002', date: '2024-01-20', items: 'Gold Chain', amount: '₹85,000', status: 'processing' },
    { id: 'ORD-2024-003', date: '2024-01-25', items: 'Pearl Earrings', amount: '₹45,000', status: 'confirmed' },
  ];

  const warrantyItems = [
    { id: 'WR-001', product: 'Diamond Ring', purchaseDate: '2023-06-15', warrantyExpiry: '2025-06-15', status: 'active' },
    { id: 'WR-002', product: 'Gold Necklace', purchaseDate: '2023-08-20', warrantyExpiry: '2025-08-20', status: 'active' },
    { id: 'WR-003', product: 'Silver Bracelet', purchaseDate: '2023-12-10', warrantyExpiry: '2025-12-10', status: 'active' },
  ];

  const loyaltyData = {
    points: 2450,
    tier: 'Gold',
    nextTier: 'Platinum',
    pointsToNext: 550,
    totalSpent: '₹4,85,000'
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-primary">My Account</h1>
          <p className="text-gray-600 mt-1">Welcome back, Anita Verma</p>
        </div>
        <div className="flex gap-3">
          <button className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-calendar-line mr-2"></i>
            Book Appointment
          </button>
          <button className="border border-primary text-primary px-4 py-2 rounded-lg hover:bg-primary/5 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-customer-service-line mr-2"></i>
            Support
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="flex space-x-8">
          {[
            { id: 'dashboard', label: 'Dashboard', icon: 'ri-dashboard-line' },
            { id: 'orders', label: 'My Orders', icon: 'ri-shopping-bag-line' },
            { id: 'warranty', label: 'Warranty', icon: 'ri-shield-check-line' },
            { id: 'loyalty', label: 'Loyalty Points', icon: 'ri-star-line' },
            { id: 'profile', label: 'Profile', icon: 'ri-user-line' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <i className={`${tab.icon} mr-2`}></i>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Dashboard Tab */}
      {activeTab === 'dashboard' && (
        <div className="space-y-6">
          {/* Quick Stats */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <div className="flex items-center">
                <div className="p-3 bg-blue-100 rounded-lg">
                  <i className="ri-shopping-bag-line text-blue-600 text-xl"></i>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-600">Total Orders</p>
                  <p className="text-2xl font-bold text-gray-900">12</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <div className="flex items-center">
                <div className="p-3 bg-green-100 rounded-lg">
                  <i className="ri-money-rupee-circle-line text-green-600 text-xl"></i>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-600">Total Spent</p>
                  <p className="text-2xl font-bold text-gray-900">₹4.85L</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <div className="flex items-center">
                <div className="p-3 bg-yellow-100 rounded-lg">
                  <i className="ri-star-line text-yellow-600 text-xl"></i>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-600">Loyalty Points</p>
                  <p className="text-2xl font-bold text-gray-900">{loyaltyData.points}</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <div className="flex items-center">
                <div className="p-3 bg-purple-100 rounded-lg">
                  <i className="ri-shield-check-line text-purple-600 text-xl"></i>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-600">Active Warranties</p>
                  <p className="text-2xl font-bold text-gray-900">3</p>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Activity */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Recent Orders</h2>
              <div className="space-y-3">
                {orderHistory.slice(0, 3).map((order) => (
                  <div key={order.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div>
                      <h3 className="font-semibold text-gray-900">{order.id}</h3>
                      <p className="text-sm text-gray-600">{order.items}</p>
                      <p className="text-xs text-gray-500">{order.date}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-medium text-gray-900">{order.amount}</p>
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        order.status === 'delivered' ? 'bg-green-100 text-green-800' :
                        order.status === 'processing' ? 'bg-blue-100 text-blue-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {order.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Loyalty Status</h2>
              <div className="space-y-4">
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-100 rounded-full mb-3">
                    <i className="ri-vip-crown-line text-yellow-600 text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{loyaltyData.tier} Member</h3>
                  <p className="text-sm text-gray-600">Current Points: {loyaltyData.points}</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-sm text-gray-600">Progress to {loyaltyData.nextTier}</span>
                    <span className="text-sm font-medium">{loyaltyData.pointsToNext} points to go</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-primary h-2 rounded-full"
                      style={{ width: `${(loyaltyData.points / (loyaltyData.points + loyaltyData.pointsToNext)) * 100}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Orders Tab */}
      {activeTab === 'orders' && (
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b">
            <h2 className="text-xl font-semibold text-primary">Order History</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Order ID</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Date</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Items</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Amount</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Status</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Actions</th>
                </tr>
              </thead>
              <tbody>
                {orderHistory.map((order) => (
                  <tr key={order.id} className="border-t">
                    <td className="px-6 py-4 font-medium">{order.id}</td>
                    <td className="px-6 py-4">{order.date}</td>
                    <td className="px-6 py-4">{order.items}</td>
                    <td className="px-6 py-4 font-medium">{order.amount}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        order.status === 'delivered' ? 'bg-green-100 text-green-800' :
                        order.status === 'processing' ? 'bg-blue-100 text-blue-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {order.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex gap-2">
                        <button className="text-blue-600 hover:text-blue-800 cursor-pointer">
                          <i className="ri-eye-line"></i>
                        </button>
                        <button className="text-green-600 hover:text-green-800 cursor-pointer">
                          <i className="ri-download-line"></i>
                        </button>
                        {order.status === 'delivered' && (
                          <button className="text-yellow-600 hover:text-yellow-800 cursor-pointer">
                            <i className="ri-star-line"></i>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Warranty Tab */}
      {activeTab === 'warranty' && (
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b">
            <h2 className="text-xl font-semibold text-primary">Warranty Management</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Warranty ID</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Product</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Purchase Date</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Warranty Expiry</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Status</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Actions</th>
                </tr>
              </thead>
              <tbody>
                {warrantyItems.map((item) => (
                  <tr key={item.id} className="border-t">
                    <td className="px-6 py-4 font-medium">{item.id}</td>
                    <td className="px-6 py-4">{item.product}</td>
                    <td className="px-6 py-4">{item.purchaseDate}</td>
                    <td className="px-6 py-4">{item.warrantyExpiry}</td>
                    <td className="px-6 py-4">
                      <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                        {item.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex gap-2">
                        <button className="text-blue-600 hover:text-blue-800 cursor-pointer">
                          <i className="ri-qr-code-line"></i>
                        </button>
                        <button className="text-green-600 hover:text-green-800 cursor-pointer">
                          <i className="ri-download-line"></i>
                        </button>
                        <button className="text-orange-600 hover:text-orange-800 cursor-pointer">
                          <i className="ri-service-line"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Loyalty Tab */}
      {activeTab === 'loyalty' && (
        <div className="space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Loyalty Program</h2>
              <div className="text-center space-y-4">
                <div className="inline-flex items-center justify-center w-24 h-24 bg-yellow-100 rounded-full">
                  <i className="ri-vip-crown-line text-yellow-600 text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">{loyaltyData.tier} Member</h3>
                  <p className="text-gray-600">Current Points: {loyaltyData.points}</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-sm text-gray-600">Progress to {loyaltyData.nextTier}</span>
                    <span className="text-sm font-medium">{loyaltyData.pointsToNext} points needed</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3">
                    <div 
                      className="bg-primary h-3 rounded-full"
                      style={{ width: `${(loyaltyData.points / (loyaltyData.points + loyaltyData.pointsToNext)) * 100}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Available Rewards</h2>
              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 border rounded-lg">
                  <div>
                    <h3 className="font-semibold">5% Discount Voucher</h3>
                    <p className="text-sm text-gray-600">Valid on next purchase</p>
                  </div>
                  <div className="text-right">
                    <p className="font-medium text-primary">500 points</p>
                    <button className="text-sm bg-primary text-white px-3 py-1 rounded cursor-pointer">
                      Redeem
                    </button>
                  </div>
                </div>
                <div className="flex items-center justify-between p-3 border rounded-lg">
                  <div>
                    <h3 className="font-semibold">Free Cleaning Service</h3>
                    <p className="text-sm text-gray-600">Professional jewelry cleaning</p>
                  </div>
                  <div className="text-right">
                    <p className="font-medium text-primary">300 points</p>
                    <button className="text-sm bg-primary text-white px-3 py-1 rounded cursor-pointer">
                      Redeem
                    </button>
                  </div>
                </div>
                <div className="flex items-center justify-between p-3 border rounded-lg">
                  <div>
                    <h3 className="font-semibold">Priority Service</h3>
                    <p className="text-sm text-gray-600">Skip the queue for 1 month</p>
                  </div>
                  <div className="text-right">
                    <p className="font-medium text-primary">1000 points</p>
                    <button className="text-sm bg-primary text-white px-3 py-1 rounded cursor-pointer">
                      Redeem
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Profile Tab */}
      {activeTab === 'profile' && (
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b">
            <h2 className="text-xl font-semibold text-primary">Profile Information</h2>
          </div>
          <div className="p-6">
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
                  <input
                    type="text"
                    defaultValue="Anita Verma"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    defaultValue="anita.verma@email.com"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                  <input
                    type="tel"
                    defaultValue="+91-9876543220"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth</label>
                  <input
                    type="date"
                    defaultValue="1985-03-15"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                <textarea
                  rows={3}
                  defaultValue="101 Rose Garden, Sector 15, Gurgaon, Haryana 122001"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20"
                ></textarea>
              </div>
              <div className="flex gap-3">
                <button
                  type="submit"
                  className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Update Profile
                </button>
                <button
                  type="button"
                  className="border border-gray-300 px-6 py-2 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}